
export default function CoursePricingSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">講習コース・料金</h2>
          <p className="text-xl sm:text-lg text-gray-600">お客様のレベルに合わせた最適なコースをご用意</p>
        </div>

        <div className="text-center mb-8">
          <div className="inline-block bg-[#FFC107] text-black px-6 py-2 rounded-full font-bold text-lg">おすすめ</div>
        </div>

        <div className="mb-16">
          <h3 className="text-3xl font-bold text-[#2A6041] mb-8 text-center">オフライン教習（全過程対面・おすすめ）</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg border-2 border-[#76B947] h-full min-h-[350px] flex flex-col">
              <div className="flex-1">
                <h4 className="text-xl font-bold text-[#2A6041] mb-3">未経験者コース</h4>
                <div className="text-3xl font-bold text-[#76B947] mb-3">
                  237,600円<span className="text-base text-gray-600">（税込）</span>
                </div>
                <div className="text-lg text-gray-600 mb-4">5日間</div>
                <ul className="space-y-2 text-gray-600 mb-4">
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">座学：17時間・実技：19時間</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">全て教習所で対面実施</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">インストラクターが直接指導</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">じっくり確実に学びたい方に最適</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border-2 border-[#76B947] h-full min-h-[350px] flex flex-col">
              <div className="flex-1">
                <h4 className="text-xl font-bold text-[#2A6041] mb-3">経験者コース</h4>
                <div className="text-3xl font-bold text-[#76B947] mb-3">
                  193,600円<span className="text-base text-gray-600">（税込）</span>
                </div>
                <div className="text-lg text-gray-600 mb-4">4日間</div>
                <ul className="space-y-2 text-gray-600 mb-4">
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">座学：17時間・実技：10時間</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">他団体の民間ドローン資格保有者向け</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">対面で丁寧にサポート</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-[#2A6041] mb-8 text-center">オンライン教習（最短コース）</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg h-full min-h-[350px] flex flex-col">
              <div className="flex-1">
                <h4 className="text-xl font-bold text-[#2A6041] mb-3">未経験者コース</h4>
                <div className="text-3xl font-bold text-[#76B947] mb-3">
                  193,600円<span className="text-base text-gray-600">（税込）</span>
                </div>
                <div className="text-lg text-gray-600 mb-4">3日間</div>
                <ul className="space-y-2 text-gray-600 mb-4">
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">座学：オンライン5時間・実技：教習所19時間</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">最短期間で資格取得</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">座学を自宅で事前学習</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg h-full min-h-[350px] flex flex-col">
              <div className="flex-1">
                <h4 className="text-xl font-bold text-[#2A6041] mb-3">経験者コース</h4>
                <div className="text-3xl font-bold text-[#76B947] mb-3">
                  138,600円<span className="text-base text-gray-600">（税込）</span>
                </div>
                <div className="text-lg text-gray-600 mb-4">2日間</div>
                <ul className="space-y-2 text-gray-600 mb-4">
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">座学：オンライン5時間・実技：教習所11時間</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">他団体の民間ドローン資格保有者向け</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-2 mt-1 flex-shrink-0"></i>
                    <span className="text-sm">期間・費用を軽減</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
